module.exports = __webpack_public_path__ + "img/yinghui.9d1f4aaa.jpg";